import { hscToppers, sscToppers, degreeToppers } from "../data";

function TopperCard({ student }) {
  return (
    <div className="topperCard">
      {student.image ? (
        <img src={student.image} alt={student.name} className="studentPhoto" />
      ) : (
        <div className="studentPhoto">Student Photo</div>
      )}

      <h4>{student.name}</h4>
      <h3>{student.score}</h3>
      <p>{student.college}</p>
    </div>
  );
}

function Toppers() {
  return (
    <section className="section" id="toppers">
      <p className="sectionTag center">Our Stars, Your Motivation</p>

      <h2 className="sectionHeading">HSC Main Stars 2024-25</h2>
      <div className="topperGrid">
        {hscToppers.map((student, index) => (
          <TopperCard student={student} key={index} />
        ))}
      </div>

      <h2 className="sectionHeading topSpace">SSC Toppers</h2>
      <div className="topperGrid smallGrid">
        {sscToppers.map((student, index) => (
          <TopperCard student={student} key={index} />
        ))}
      </div>

      <h2 className="sectionHeading topSpace">T.Y.BCOM / BMS Toppers</h2>
      <div className="topperGrid smallGrid">
        {degreeToppers.map((student, index) => (
          <TopperCard student={student} key={index} />
        ))}
      </div>
    </section>
  );
}

export default Toppers;